export default __webpack_public_path__ + "static/media/add-contact.26ef3120.svg";